import api from './api';

export const practiceComplianceAPI = {
  overview: () => api.get('/api/compliance/overview'),
  getProfile: () => api.get('/api/compliance/profile'),
  saveProfile: (data) => api.put('/api/compliance/profile', data),
  listManuals: () => api.get('/api/compliance/manuals'),
  generate: (templateKeys) => api.post('/api/compliance/manuals/generate', { template_keys: templateKeys || null }),
  getManual: (id) => api.get(`/api/compliance/manuals/${id}`),
  getVersion: (id, vid) => api.get(`/api/compliance/manuals/${id}/versions/${vid}`),
  editSection: (id, vid, key, data) => api.patch(`/api/compliance/manuals/${id}/versions/${vid}/sections/${key}`, data),
  submitReview: (id, vid) => api.post(`/api/compliance/manuals/${id}/versions/${vid}/submit-review`),
  approve: (id, vid, data) => api.post(`/api/compliance/manuals/${id}/versions/${vid}/approve`, data),
  newDraft: (id, data) => api.post(`/api/compliance/manuals/${id}/new-draft`, data),
  acknowledge: (id) => api.post(`/api/compliance/manuals/${id}/acknowledge`),
  ackMatrix: () => api.get('/api/compliance/acknowledgements'),
  listRisks: () => api.get('/api/compliance/risks'),
  createRisk: (data) => api.post('/api/compliance/risks', data),
  updateRisk: (id, data) => api.patch(`/api/compliance/risks/${id}`, data),
  reviewRisk: (id) => api.post(`/api/compliance/risks/${id}/review`),
  downloadPdf: (id, versionId) => api.get(`/api/compliance/manuals/${id}/pdf${versionId ? `?version_id=${versionId}` : ''}`, { responseType: 'blob' }),
};

export const MANUAL_STATUS_META = {
  draft: { label: 'Draft', color: 'bg-amber-100 text-amber-800' },
  in_review: { label: 'In Review', color: 'bg-blue-100 text-blue-800' },
  approved_effective: { label: 'Effective', color: 'bg-green-100 text-green-800' },
  superseded: { label: 'Superseded', color: 'bg-muted text-muted-foreground' },
};

export const RISK_BAND_META = {
  low: { label: 'Low', color: 'bg-green-100 text-green-800' },
  moderate: { label: 'Moderate', color: 'bg-yellow-100 text-yellow-800' },
  high: { label: 'High', color: 'bg-orange-100 text-orange-800' },
  critical: { label: 'Critical', color: 'bg-red-100 text-red-800' },
};

export const SERVICE_OPTIONS = [
  { key: 'tax_returns', label: 'Tax returns' },
  { key: 'bas_gst', label: 'BAS / GST' },
  { key: 'bookkeeping', label: 'Bookkeeping' },
  { key: 'payroll', label: 'Payroll' },
  { key: 'financial_statements', label: 'Financial statements' },
  { key: 'smsf_accounting', label: 'SMSF accounting & tax' },
  { key: 'advisory', label: 'Advisory' },
  { key: 'audit_assurance', label: 'Audit & assurance' },
];

export const STRUCTURE_OPTIONS = [
  { key: 'sole_practitioner', label: 'Sole practitioner' },
  { key: 'partnership', label: 'Partnership' },
  { key: 'company', label: 'Company' },
  { key: 'trust', label: 'Trust' },
];

export const riskBand = (score) => (score >= 17 ? 'critical' : score >= 10 ? 'high' : score >= 5 ? 'moderate' : 'low');

export const downloadManualPdf = async (manualId, versionId, filename) => {
  const res = await practiceComplianceAPI.downloadPdf(manualId, versionId);
  const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename || 'practice-manual'}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
